import {
  useGetFormattedDurationFieldLabels,
  useGetQuantifyCompareQuery,
  useIsDashboardDurationApplied,
} from '@modules/quantify/hooks';
import { Stack, Typography } from '@mui/material';

interface CompareDurationDefinitionInfoProps {
  compareField: 'A' | 'B';
}

export const CompareDurationDefinitionInfo = ({
  compareField,
}: CompareDurationDefinitionInfoProps) => {
  const compareQuery = useGetQuantifyCompareQuery();

  const { durationLabel, compareDurationLabel } =
    useGetFormattedDurationFieldLabels();

  const isDashboardDurationApplied = useIsDashboardDurationApplied();

  if (!!compareQuery?.timerange && !!compareQuery?.previousPeriod) {
    return null;
  }

  if (compareField === 'A') {
    return (
      <Stack>
        <Typography
          variant="caption"
          color={isDashboardDurationApplied ? 'info.main' : 'inherit'}
        >
          {durationLabel.primary}
        </Typography>
        {durationLabel.secondary && (
          <Typography
            variant="caption"
            color={isDashboardDurationApplied ? 'info.main' : 'inherit'}
          >
            {durationLabel.secondary}
          </Typography>
        )}
      </Stack>
    );
  }

  return (
    <Stack>
      <Typography variant="caption" color="inherit">
        {compareDurationLabel.primary}
      </Typography>
      {compareDurationLabel.secondary && (
        <Typography variant="caption" color="inherit">
          {compareDurationLabel.secondary}
        </Typography>
      )}
    </Stack>
  );
};
